import SizeHelpers from './size-helpers';

const allPhotos = (sizes) => {
  return SizeHelpers.augment.fromCollection(sizes);
};

const allPhotosCollectedByRootImage = (sizes) => {
  return allPhotos(sizes).reduce((acc, photo) => {
    const { root_image_id: rootId, sizeKey } = photo;

    if (!acc[rootId]) {
      acc[rootId] = {};
    }

    if (!acc[rootId][sizeKey]) {
      acc[rootId][sizeKey] = [];
    }

    acc[rootId][sizeKey].push(photo);

    return acc;
  }, {});
};

export { allPhotosCollectedByRootImage };
